import { createStore } from 'satcheljs';
export default createStore('calendarConfiguration', {
    mailboxJunkEmailConfiguration: null,
})();
//# sourceMappingURL=store.js.map